import { Flatfile } from "@flatfile/api";
import { IBulkBatch } from "@wingspanhq/payments/dist/interfaces";
import { useQueryFlatfileUploadJob } from "../query/flatfile/queries";

/**
 * Progress and outcome of the Flatfile job that uploads the spreadsheet rows into the batch.
 *
 * `isFailed` means the upload died before finishing (a server error on our side or on Flatfile's
 * side), which leaves the batch partially uploaded forever: the batch keeps the "uploading"
 * state because `uploadFinishedAt` is never set.
 */
export function useFlatfileUploadJobStatus(bulkBatch?: IBulkBatch): {
  progress: number;
  isFailed: boolean;
} {
  const queryFlatfileUploadJob = useQueryFlatfileUploadJob(bulkBatch);
  const uploadJob = queryFlatfileUploadJob.data;

  return {
    progress: uploadJob?.progress || 0,
    isFailed: uploadJob?.status === Flatfile.JobStatus.Failed
  };
}
